import React from "react";
import { AppSelectButtonWrapper } from "../styled/styled";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { SvgIcon } from "@mui/material";
import { APPLICATION } from "../constants/common";
import { AppSelectHandler } from "../types/common";

type Props = { Icon: typeof SvgIcon; text: string; value: APPLICATION; onClick: AppSelectHandler };

const SelectButton: React.FC<Props> = ({ Icon, text, value, onClick }) => {
  return (
    <AppSelectButtonWrapper onClick={() => onClick(value)}>
      <div className="icon-text">
        <Icon /> <span>{text}</span>
      </div>
      <ChevronRightIcon />
    </AppSelectButtonWrapper>
  );
};

export default SelectButton;
